import { SchedulerService } from '../../shared/services/scheduler.service';
import { LazyLoadableModuleId } from '../lazy-loadable-module-id.enum';
import { ModulePriorityService } from '../module-priority.service';
import { LazyViewDownloadStrategy } from './lazy-view-download-strategy.service';

export class SchedulerDownloadStrategy implements LazyViewDownloadStrategy {
    constructor(
        private readonly scheduler: SchedulerService,
        private readonly modulePriorityService: ModulePriorityService
    ) {
    }

    public shouldLoad(moduleId: LazyLoadableModuleId): Promise<void> {
        const priority = this.modulePriorityService.getSchedulePriority(moduleId);

        return new Promise<any>(resolve => this.scheduler.scheduleWork(resolve, priority));
    }
}
